/**
 * Alaska: App.js (PWA)
 * Store: State (Handles routing + view injection)
 * @version 1.0
 */
document.addEventListener("alpine:init", () => {

    Alpine.store("state", {
        history: [],
        background: null,

        current_module: null,
        current_page: null,
        params: {},

        init() {
            Debug.log("[STATE] init()", "info");
            this.load();
        },

        load(module = null, page = "index", payload = {}) {
            Debug.log("[STATE] load()", "info");
            Debug.log({module, page});

            this.loading = true;

            // Save previous module/page into history
            if (this.current_module !== null || this.current_page !== null) {
                const user_is_logged_in = Alpine.store('user')?.logged_in;

                const history_entry = {
                    module: this.current_module,
                    page: this.current_page,
                    container: (!user_is_logged_in || this.current_page !== "index") ? "child" : "main"
                };

                this.history.push(history_entry);

                // Debug.log(`[STATE] Pushed to history:`);
                Debug.log(history_entry);
            }

            this.params = (payload && typeof payload === "object") ? payload : {};

            const params = new URLSearchParams({action: "load", page});
            Object.entries(this.params).forEach(([key, value]) => {
                if (value === undefined || value === null) return;
                params.append(key, String(value));
            });
            if (module && module !== "index") params.append("module", module);
            const url = `/?${params.toString()}`;

            const main = document.querySelector('[data-container="main"]');
            const child = document.querySelector('[data-container="child"]');
            const same_module = module === this.current_module;
            const is_parent = (page === 'index');

            // Debug.log(`[STATE] Fetching URL: ${url}`);

            fetch(url)
                .then(res => res.json())
                .then(async json => {
                    if (json.type === "redirect") {
                        // Debug.log(`[STATE] Redirect detected to: ${json.location}`, "warning");
                        return this.load(json.location, "index")
                    }

                    if (json.type !== "success") {
                        throw new Error(json.message || "Unknown error")
                    }

                    await this.wait_until_user_ready();

                    const background = json.background || '';
                    if (background) {
                        // Debug.log(`[STATE] Background class: ${background}`)
                    }

                    if (same_module && !is_parent && Alpine.store("user")?.logged_in) {
                        Debug.log("[STATE] Same module, rendering in 'child' container", "warning");
                        child.innerHTML = json.data;
                        Alpine.initTree(child);

                        child.className = `xtra-app-content ${background}`.trim();
                        child.classList.remove('hidden');

                        requestAnimationFrame(() => {
                            void child.offsetWidth;
                            child.classList.add('animate-slide-in-from-right');
                            Debug.log("[STATE] Slide IN animation started on child");
                        });

                        child.addEventListener('animationend', () => {
                            child.classList.remove('animate-slide-in-from-right');
                            Debug.log("[STATE] Slide IN animation ended on child");
                        }, {once: true});

                        main.classList.add('hidden');

                    } else {
                        Debug.log("[STATE] Different module or parent page requested, rendering in 'main' container", "warning");
                        child.classList.add('hidden');
                        child.innerHTML = '';

                        main.innerHTML = json.data;
                        Alpine.initTree(main);

                        main.className = `xtra-app-content ${background}`.trim();
                    }

                    if (["dashboard", "schedule", "details", "documents"].includes(module)) {
                        // Debug.log(`[STATE] Setting active navigation: ${module}`, "success");
                        Alpine.store("navigation").active = module;
                    }

                    this.current_module = module;
                    this.current_page = page;

                    // Debug.log("[STATE] Updated current_module and current_page:");
                    // Debug.log(`[STATE]  - current_module: ${this.current_module}`);
                    // Debug.log(`[STATE]  - current_page: ${this.current_page}`);

                })
                .catch(error => {
                    console.error(`[STATE] Load Error: ${error}`);
                })
                .finally(() => {
                    this.loading = false;
                    Debug.log("[STATE] Load complete", "success");
                });
        },

        back() {

            // If not logged in, always go back to core app shell
            if (!Alpine.store("user").logged_in) {
                this.load(null, "index");
                this.history = [];
                return;
            }

            if (!this.history.length) {
                Debug.log("[STATE] No history to go back to");
                return;
            }

            const previous = this.history.pop();
            if (!previous) {
                Debug.log("[STATE] Previous history item was empty");
                return;
            }

            // Debug.log(`[STATE] Going back to: ${previous}`);

            const {container} = previous;

            const main = document.querySelector('[data-container="main"]');
            const child = document.querySelector('[data-container="child"]');

            if (container === "main") {
                Debug.log("[STATE] Sliding child OUT to reveal parent...");

                child.classList.remove('hidden');

                requestAnimationFrame(() => {
                    void child.offsetWidth; // Force reflow
                    child.classList.add('animate-slide-out-to-right');
                    Debug.log("[STATE] Slide OUT animation started on child");
                });

                setTimeout(() => {
                    Debug.log("[STATE] Setting Parent to Visible");
                    main.classList.remove('hidden')
                }, 250);

                child.addEventListener('animationend', () => {
                    child.classList.remove('animate-slide-out-to-right');
                    child.classList.add('hidden');
                    child.innerHTML = '';
                    Debug.log("[STATE] Slide OUT animation ended. Child hidden and cleared.");

                }, {once: true});

                this.current_page = 'index';

            } else {
                Debug.log("[STATE] Re-loading main page (different module or page)", "warning");
                this.load(previous.module || null, previous.page || "index");
            }
        },

        async wait_until_user_ready() {
            Debug.log("[STATE] Waiting until user is ready...", "warning");
            while (!Alpine.store('user')?.ready) {
                await new Promise(resolve => setTimeout(resolve, 50));
            }
            Debug.log("[STATE] User ready", "success");
        }
    });
});